{
  "labels": {
    "paste": "جای گذاری",
    "pasteAsPlaintext": "جای‌گذاری به عنوان متن ساده",
    "pasteCharts": "قراردادن نمودارها",
    "selectAll": "انتخاب همه",
    "multiSelect": "یک ایتم به انتخاب شده ها اضافه کنید.",
    "moveCanvas": "جابجایی بوم",
    "cut": "بریدن",
    "copy": "کپی",
    "copyAsPng": "کپی در حافطه موقت به صورت PNG",
    "copyAsSvg": "کپی در حافطه موقت به صورت SVG",
    "copyText": "کپی در حافطه موقت به صورت متن",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "جلو آوردن",
    "sendToBack": "پس فرستادن",
    "bringToFront": "جلو آوردن",
    "sendBackward": "پس فرستادن",
    "delete": "حذف",
    "copyStyles": "کپی سبک",
    "pasteStyles": "جای گذاری سبک",
    "stroke": "حاشیه",
    "background": "پس زمینه",
    "fill": "رنگ آمیزی",
    "strokeWidth": "ضخامت حاشیه",
    "strokeStyle": "استایل حاشیه",
    "strokeStyle_solid": "یکدست",
    "strokeStyle_dashed": "خط چین",
    "strokeStyle_dotted": "نقطه چین",
    "sloppiness": "دقت",
    "opacity": "شفافیت",
    "textAlign": "چیدمان متن",
    "edges": "لبه ها",
    "sharp": "تیز",
    "round": "دور",
    "arrowheads": "سر پیکان",
    "arrowhead_none": "هیچ کدام",
    "arrowhead_arrow": "پیکان",
    "arrowhead_bar": "میله ای",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "مثلث",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "اندازه قلم",
    "fontFamily": "نوع قلم",
    "addWatermark": "\"ساخته شده با Excalidraw\" را اضافه کن",
    "handDrawn": "دست نویس",
    "normal": "عادی",
    "code": "کد",
    "small": "کوچک",
    "medium": "متوسط",
    "large": "بزرگ",
    "veryLarge": "بسیار بزرگ",
    "solid": "توپر",
    "hachure": "هاشور",
    "zigzag": "زیگزاگ",
    "crossHatch": "هاشور متقاطع",
    "thin": "نازک",
    "bold": "ضخیم",
    "left": "چپ",
    "center": "وسط",
    "right": "راست",
    "extraBold": "خیلی ضخیم",
    "architect": "معمار",
    "artist": "هنرمند",
    "cartoonist": "کارتونیست",
    "fileTitle": "نام فایل",
    "colorPicker": "انتخابگر رنگ",
    "canvasColors": "رنگ های بوم",
    "canvasBackground": "بوم",
    "drawingCanvas": "بوم نقاشی",
    "layers": "لایه ها",
    "actions": "عملیات",
    "language": "زبان",
    "liveCollaboration": "همکاری آنلاین...",
    "duplicateSelection": "تکرار",
    "untitled": "بدون عنوان",
    "name": "نام",
    "yourName": "نام شما",
    "madeWithExcalidraw": "ساخته شده با Excalidraw",
    "group": "گروهبندی انتخابها",
    "ungroup": "حذف گروهبندی انتخابها",
    "collaborators": "همکاران",
    "showGrid": "نمایش گرید",
    "addToLibrary": "افزودن به کتابخانه",
    "removeFromLibrary": "حذف از کتابخانه",
    "libraryLoadingMessage": "بارگذاری کتابخانه…",
    "libraries": "مرور کردن کتابخانه ها",
    "loadingScene": "باگذاری صحنه…",
    "align": "تراز",
    "alignTop": "تراز به بالا",
    "alignBottom": "تراز به پایین",
    "alignLeft": "تراز به چپ",
    "alignRight": "تراز به راست",
    "centerVertically": "وسط قرار دادن به صورت عمودی",
    "centerHorizontally": "وسط قرار دادن به صورت افقی",
    "distributeHorizontally": "توزیع کردن به صورت افقی",
    "distributeVertically": "توزیع کردن به صورت عمودی",
    "flipHorizontal": "چرخش افقی",
    "flipVertical": "چرخش عمودی",
    "viewMode": "حالت نمایش",
    "share": "اشتراک‌گذاری",
    "showStroke": "نمایش انتخاب کننده رنگ حاشیه",
    "showBackground": "نمایش انتخاب کننده رنگ پس زمینه",
    "toggleTheme": "تغییر تم",
    "personalLib": "کتابخانه شخصی",
    "excalidrawLib": "کتابخانه",
    "decreaseFontSize": "کاهش اندازه فونت",
    "increaseFontSize": "افزایش دادن اندازه فونت",
    "unbindText": "بازکردن نوشته",
    "bindText": "بستن نوشته",
    "createContainerFromText": "متن را در یک جایگاه بپیچید",
    "link": {
      "edit": "ویرایش لینک",
      "editEmbed": "",
      "create": "ایجاد پیوند",
      "createEmbed": "",
      "label": "لینک",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "ویرایش لینک",
      "exit": "خروج از ویرایشگر"
    },
    "elementLock": {
      "lock": "قفل",
      "unlock": "باز کردن",
      "lockAll": "قفل همه",
      "unlockAll": "باز کردن قفل همه"
    },
    "statusPublished": "منتشر شده",
    "sidebarLock": "باز نگه داشتن سایدبار",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "انتخاب رنگ از کرباس",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "آیتمی به اینجا اضافه نشده...",
    "hint_emptyLibrary": "یک آیتم روی بوم را برای اضافه شده به اینجا انتخاب کنید، یا یک کتابخانه از مخزن عمومی در بخش پایین را نصب کنید.",
    "hint_emptyPrivateLibrary": "یک آیتم روی بوم را برای اضافه شدن به اینجا انتخاب کنید."
  },
  "buttons": {
    "clearReset": "پاکسازی بوم نقاشی",
    "exportJSON": "خروجی در فایل",
    "exportImage": "خروجی گرفتن از تصویر...",
    "export": "ذخیره در...",
    "copyToClipboard": "کپی در حافظه موقت",
    "save": "ذخیره در همین فایل",
    "saveAs": "ذخیره با نام",
    "load": "باز کردن",
    "getShareableLink": "دریافت لینک قابل اشتراک",
    "close": "بستن",
    "selectLanguage": "انتخاب زبان",
    "scrollBackToContent": "به محتوا بروید",
    "zoomIn": "بزرگ نمایی",
    "zoomOut": "کوچک نمایی",
    "resetZoom": "اندازه اصلی",
    "menu": "فهرست",
    "done": "انجام شد",
    "edit": "ویرایش",
    "undo": "بازگرد",
    "redo": "از سر",
    "resetLibrary": "تنظیم مجدد کتابخانه",
    "createNewRoom": "ایجاد یک اتاق جدید",
    "fullScreen": "تمام‌صفحه",
    "darkMode": "حالت تیره",
    "lightMode": "حالت روشن",
    "zenMode": "حالت ذن",
    "objectsSnapMode": "",
    "exitZenMode": "خروج از حالت تمرکز",
    "cancel": "لغو",
    "clear": "پاک کردن",
    "remove": "پاک کردن",
    "embed": "",
    "publishLibrary": "انتشار",
    "submit": "ارسال",
    "confirm": "تایید",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "این کار کل صفحه را پاک میکند. آیا مطمئنید؟",
    "couldNotCreateShareableLink": "عدم توانایی در ساخت یک لینک قابل اشتراک.",
    "couldNotCreateShareableLinkTooBig": "لینک قابل اشتراک گذاری ایجاد نشد: محتوای صحنه بسیار بزرگ است",
    "couldNotLoadInvalidFile": "عدم توانایی در بازگذاری فایل نامعتبر",
    "importBackendFailed": "بارگیری از پشت صحنه با شکست مواجه شد.",
    "cannotExportEmptyCanvas": "بوم خالی قابل تبدیل نیست.",
    "couldNotCopyToClipboard": "به کلیپ بورد کپی نشد.",
    "decryptFailed": "رمزگشایی داده ها امکان پذیر نیست.",
    "uploadedSecurly": "آپلود با رمزگذاری دو طرفه انجام میشود، به این معنی که سرور Excalidraw و اشخاص ثالث نمی توانند مطالب شما را بخوانند.",
    "loadSceneOverridePrompt": "بارگزاری یک طرح خارجی محتوای فعلی رو از بین میبرد. آیا میخواهید ادامه دهید؟",
    "collabStopOverridePrompt": "با توقف بوم نقاشی، نقشه قبلی و ذخیره شده محلی شما را بازنویسی می کند. مطمئنی؟\n\n(اگر می خواهید نقاشی محلی خود را حفظ کنید، به سادگی برگه مرورگر را ببندید.)",
    "errorAddingToLibrary": "مورد به کتابخانه اضافه نشد",
    "errorRemovingFromLibrary": "مورد از کتابخانه حذف نشد",
    "confirmAddLibrary": "{{numShapes}} از اشکال به کتابخانه شما اضافه خواهد شد. مطمئن هستید؟",
    "imageDoesNotContainScene": "به نظر نمی رسد این تصویر حاوی داده های بوم نقاشی باشد. آیا جاسازی صحنه را در حین خروجی فعال کرده اید?",
    "cannotRestoreFromImage": "صحنه را نمی توان از این فایل تصویری بازیابی کرد",
    "invalidSceneUrl": "بوم نقاشی از آدرس ارائه شده وارد نشد. این یا نادرست است، یا حاوی داده Excalidraw JSON معتبر نیست.",
    "resetLibrary": "ین کار کل صفحه را پاک میکند. آیا مطمئنید?",
    "removeItemsFromsLibrary": "حذف {{count}} آیتم(ها) از کتابخانه?",
    "invalidEncryptionKey": "کلید رمزگذاری باید 22 کاراکتر باشد. همکاری زنده غیرفعال است.",
    "collabOfflineWarning": "اتصال به اینترنت در دسترس نیست.\nتغییرات شما ذخیره نمی شود!"
  },
  "errors": {
    "unsupportedFileType": "نوع فایل پشتیبانی نشده.",
    "imageInsertError": "عکس ارسال نشد. بعداً دوباره تلاش کنید...",
    "fileTooBig": "فایل خیلی بزرگ است حداکثر اندازه مجاز {{maxSize}}.",
    "svgImageInsertError": "تصویر SVG وارد نشد. نشانه گذاری SVG نامعتبر به نظر می رسد.",
    "failedToFetchImage": "",
    "invalidSVGString": "SVG نادرست.",
    "cannotResolveCollabServer": "به سرور collab متصل نشد. لطفا صفحه را مجددا بارگذاری کنید و دوباره تلاش کنید.",
    "importLibraryError": "داده‌ها بارگذاری نشدند",
    "collabSaveFailed": "در پایگاه داده باطن ذخیره نشد. اگر مشکلات همچنان ادامه داشت، باید فایل خود را به صورت محلی ذخیره کنید تا مطمئن شوید کار خود را از دست نمی دهید.",
    "collabSaveFailed_sizeExceeded": "در پایگاه داده بکند ذخیره نشد. اگر مشکلات همچنان ادامه داشت، باید فایل خود را به صورت محلی ذخیره کنید تا مطمئن شوید کار خود را از دست نمی دهید.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "به نظر می‌رسد از مرورگر Brave با تنظیم <bold> مسدود کردن شدید اثرانگشت</bold> استفاده می‌کنید.",
      "line2": "این می تواند منجر به شکستن <bold>عناصر متن</bold> در نقاشی های شما شود.",
      "line3": "اکیداً توصیه می کنیم این تنظیم را غیرفعال کنید. برای نحوه انجام این کار می‌توانید <link>این مراحل</link> را دنبال کنید.",
      "line4": "اگر غیرفعال کردن این تنظیم نمایش عناصر متنی را برطرف نکرد، لطفاً یک <issueLink>مشکل</issueLink> را در GitHub ما باز کنید یا برای ما در <discordLink>Discord</discordLink> بنویسید."
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "گزینش",
    "image": "وارد کردن تصویر",
    "rectangle": "مستطیل",
    "diamond": "لوزی",
    "ellipse": "بیضی",
    "arrow": "پیکان",
    "line": "خط",
    "freedraw": "کشیدن",
    "text": "متن",
    "library": "کتابخانه",
    "lock": "ابزار انتخاب شده را بعد از کشیدن نگه دار",
    "penMode": "حالت قلم - جلوگیری از تماس",
    "link": "افزودن/به‌روزرسانی پیوند برای شکل انتخابی",
    "eraser": "پاک کن",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "دست (ابزار پانینگ)",
    "extraTools": "ابزارهای بیشتر",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "عملیات روی بوم",
    "selectedShapeActions": "عملیات روی شکل انتخاب شده",
    "shapes": "شکل‌ها"
  },
  "hints": {
    "canvasPanning": "برای حرکت دادن بوم، چرخ ماوس یا فاصله را در حین کشیدن نگه دارید یا از ابزار دستی استفاده کنید",
    "linearElement": "برای چند نقطه کلیک و برای یک خط بکشید",
    "freeDraw": "کلیک کنید و بکشید و وقتی کار تمام شد رها کنید",
    "text": "نکته: با برنامه انتخاب شده شما میتوانید با دوبار کلیک کردن هرکجا میخواید متن اظاف کنید",
    "embeddable": "",
    "text_selected": "دوبار کلیک کنید یا Enter را فشار دهید تا نقاط را ویرایش کنید",
    "text_editing": "Escape یا CtrlOrCmd+ENTER را فشار دهید تا ویرایش تمام شود",
    "linearElementMulti": "روی آخرین نقطه کلیک کنید یا کلید ESC را بزنید یا کلید Enter را بزنید برای اتمام کار",
    "lockAngle": "با نگه داشتن SHIFT هنگام چرخش می توانید زاویه ها را محدود کنید",
    "resize": "می توانید با نگه داشتن SHIFT در هنگام تغییر اندازه، نسبت ها را محدود کنید،ALT را برای تغییر اندازه از مرکز نگه دارید",
    "resizeImage": "با نگه داشتن SHIFT می توانید آزادانه اندازه را تغییر دهید،\nبرای تغییر اندازه از مرکز، ALT را نگه دارید",
    "rotate": "با نگه داشتن SHIFT هنگام چرخش می توانید زاویه ها را محدود کنید",
    "lineEditor_info": "CtrlOrCmd را نگه دارید و دوبار کلیک کنید یا CtrlOrCmd + Enter را فشار دهید تا نقاط را ویرایش کنید.",
    "lineEditor_pointSelected": "برای حذف نقطه Delete برای کپی زدن Ctrl یا Cmd+D را بزنید و یا برای جابجایی بکشید",
    "lineEditor_nothingSelected": "یک نقطه را برای ویرایش انتخاب کنید (SHIFT را برای انتخاب چندگانه نگه دارید)،\nیا Alt را نگه دارید و برای افزودن نقاط جدید کلیک کنید",
    "placeImage": "برای قرار دادن تصویر کلیک کنید، یا کلیک کنید و بکشید تا اندازه آن به صورت دستی تنظیم شود",
    "publishLibrary": "کتابخانه خود را منتشر کنید",
    "bindTextToElement": "برای افزودن اینتر را بزنید",
    "deepBoxSelect": "CtrlOrCmd را برای انتخاب عمیق و جلوگیری از کشیدن نگه دارید",
    "eraserRevert": "Alt را نگه دارید تا عناصر علامت گذاری شده برای حذف برگردند",
    "firefox_clipboard_write": "احتمالاً می‌توان این ویژگی را با تنظیم پرچم «dom.events.asyncClipboard.clipboardItem» روی «true» فعال کرد. برای تغییر پرچم های مرورگر در فایرفاکس، از صفحه \"about:config\" دیدن کنید.",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "پیش نمایش نشان داده نمی شود",
    "canvasTooBig": "بوم نقاشی بسیار بزرگ است.",
    "canvasTooBigTip": "نکته: سعی کنید دورترین عناصر را کمی به همدیگر نزدیک کنید."
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "اگر بازنشانی صفحه مشکل را حل نکرد این را امتحان کنید ",
    "clearCanvasCaveat": " این باعث میشود کارهای شما ذخیره نشود ",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": "محتوای صحنه:"
  },
  "roomDialog": {
    "desc_intro": "می توانید افرادی را به صحنه فعلی خود دعوت کنید تا با شما همکاری کنند.",
    "desc_privacy": "نگران نباشید، این جلسه از رمزگذاری دوطرفه استفاده می کند، پس هر چیزی بکشید خصوصی خواهد ماند. حتی سرور ما نمیتواند ببیند چیزی که شما طراحی میکنید.",
    "button_startSession": "شروع جلسه",
    "button_stopSession": "پایان جلسه",
    "desc_inProgressIntro": "جلسه همکاری آنلاین در حال انجام است.",
    "desc_shareLink": "این لینک را با هر کسی که می خواهید با او همکاری کنید به اشتراک بگذارید:",
    "desc_exitSession": "با پایان دادن جلسه، شما از اتاق حذف میکند، اما می توانید به صورت محلی کار خود را با بوم ادامه دهید. توجه داشته باشید که این مورد بر سایر افراد تأثیر نمی گذارد و همچنان می توانند در نسخه خود همکاری کنند.",
    "shareTitle": "به یک جلسه همکاری زنده در Excalidraw بپیوندید"
  },
  "errorDialog": {
    "title": "خطا"
  },
  "exportDialog": {
    "disk_title": "ذخیره در دیسک",
    "disk_details": "داده های صحنه را به فایلی که بعداً می توانید از آن وارد کنید صادر کنید.",
    "disk_button": "ذخیره در فایل",
    "link_title": "لینک قابل اشتراک‌گذاری",
    "link_details": "خروجی به عنوان یک پیوند فقط خواندنی.",
    "link_button": "خروجی در فایل",
    "excalidrawplus_description": "صحنه را در فضای کاری Excalidraw+ خود ذخیره کنید.",
    "excalidrawplus_button": "خروجی گرفتن",
    "excalidrawplus_exportError": "در حال حاضر نمی‌توان به Excalidraw+ صادر کرد..."
  },
  "helpDialog": {
    "blog": "بلاگ ما را بخوانید",
    "click": "کلیک",
    "deepSelect": "انتخاب عمیق",
    "deepBoxSelect": "انتخاب عمیق در کادر، و جلوگیری از کشیدن",
    "curvedArrow": "فلش خمیده",
    "curvedLine": "منحنی",
    "documentation": "مستندات",
    "doubleClick": "دابل کلیک",
    "drag": "کشیدن",
    "editor": "ویرایشگر",
    "editLineArrowPoints": "نقاط خط/پیکان را ویرایش کنید",
    "editText": "ویرایش متن / افزودن برچسب",
    "github": "اشکالی می بینید؟ گزارش دهید",
    "howto": "راهنمای ما را دنبال کنید",
    "or": "یا",
    "preventBinding": "مانع شدن از چسبیدن فلش ها",
    "tools": "ابزار",
    "shortcuts": "میانبرهای صفحه کلید",
    "textFinish": "پایان ویرایش (ویرایشگر متن)",
    "textNewLine": "افزودن خط جدید (ویرایشگر متن)",
    "title": "راهنما",
    "view": "مشاهده",
    "zoomToFit": "بزرگنمایی برای دیدن تمام آیتم ها",
    "zoomToSelection": "بزرگنمایی قسمت انتخاب شده",
    "toggleElementLock": "قفل/بازکردن انتخاب شده ها",
    "movePageUpDown": "حرکت صفحه به بالا/پایین",
    "movePageLeftRight": "حرکت صفحه به چپ/راست"
  },
  "clearCanvasDialog": {
    "title": "پاک کردن بوم"
  },
  "publishDialog": {
    "title": "انتشار کتابخانه",
    "itemName": "نام آیتم",
    "authorName": "نام نویسنده",
    "githubUsername": "نام کاربری گیت هاب",
    "twitterUsername": "نام کاربری توییتر",
    "libraryName": "نام کتابخانه",
    "libraryDesc": "توضیحات کتابخانه",
    "website": "تارنما",
    "placeholder": {
      "authorName": "نام یا نام کاربری شما",
      "libraryName": "اسم کتابخانه",
      "libraryDesc": "شرحی از کتابخانه شما برای کمک به مردم برای درک استفاده از آن",
      "githubHandle": "دسته GitHub (اختیاری)، بنابراین می توانید پس از ارسال برای بررسی، کتابخانه را ویرایش کنید",
      "twitterHandle": "نام کاربری توییتر (اختیاری)، بنابراین می دانیم هنگام تبلیغ در توییتر به چه کسی اعتبار دهیم",
      "website": "پیوند به وب سایت شخصی شما یا هر جای دیگر (اختیاری)"
    },
    "errors": {
      "required": "لازم",
      "website": "وارد کردن آدرس درست"
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "هر مورد کتابخانه باید نام خاص خود را داشته باشد تا قابل فیلتر باشد. اقلام کتابخانه زیر شامل خواهد شد:",
    "atleastOneLibItem": "لطفاً حداقل یک مورد از کتابخانه را برای شروع انتخاب کنید",
    "republishWarning": "توجه: برخی از موارد انتخاب شده به عنوان قبلاً منتشر شده/ارسال شده علامت گذاری شده اند. شما فقط باید هنگام به‌روزرسانی یک کتابخانه موجود یا ارسال، موارد را دوباره ارسال کنید."
  },
  "publishSuccessDialog": {
    "title": "کتابخانه ارسال شد",
    "content": "تشکر از شما {{authorName}}. کتابخانه شما برای بررسی ارسال شده است. می توانید وضعیت را پیگیری کنید"
  },
  "confirmDialog": {
    "resetLibrary": "تنظیم مجدد کتابخانه",
    "removeItemsFromLib": "موارد انتخاب شده از موارد پسندیده حذف شوند"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "پس زمینه",
      "onlySelected": "",
      "darkMode": "حالت تیره",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "کپی در کلیپ‌بورد"
    }
  },
  "encrypted": {
    "tooltip": "شما در یک محیط رمزگزاری شده دو طرفه در حال طراحی هستید پس Excalidraw هرگز طرح های شما را نمیبند.",
    "link": "پست وبلاگ در مورد رمزگذاری سرتاسر در Excalidraw"
  },
  "stats": {
    "angle": "زاویه",
    "element": "اِلمان",
    "elements": "اِلمان ها",
    "height": "ارتفاع",
    "scene": "صحنه",
    "selected": "انتخاب شده",
    "storage": "حافظه",
    "title": "آمار برای نردها",
    "total": "مجموع",
    "version": "نسخه",
    "versionCopy": "برای کپی کردن کلیک کنید",
    "versionNotAvailable": "نسخه غیرقابل دسترس",
    "width": "عرض"
  },
  "toast": {
    "addedToLibrary": "به مجموعه اضافه شد",
    "copyStyles": "کپی سبک.",
    "copyToClipboard": "در کلیپ‌بورد کپی شد.",
    "copyToClipboardAsPng": "کپی {{exportSelection}} در کلیپبورد به عنوان PNG\n({{exportColorScheme}})",
    "fileSaved": "فایل ذخیره شد.",
    "fileSavedToFilename": "ذخیره در {filename}",
    "canvas": "بوم",
    "selection": "انتخاب",
    "pasteAsSingleElement": "از {{shortcut}} برای چسباندن به عنوان یک عنصر استفاده کنید،\nیا در یک ویرایشگر متن موجود جایگذاری کنید",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "شفاف",
    "black": "سیاه",
    "white": "سفید",
    "red": "قرمز",
    "pink": "صورتی",
    "grape": "یاقوتی",
    "violet": "بنفش",
    "gray": "خاکستری",
    "blue": "آبی",
    "cyan": "فیروزه‌ای",
    "teal": "سبزآبی",
    "green": "سبز",
    "yellow": "زرد",
    "orange": "نارنجی",
    "bronze": "برنزی"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "تمام داده های شما به صورت محلی در مرورگر شما ذخیره می شود.",
      "center_heading_plus": "آیا می‌خواهید به جای آن به Excalidraw+ بروید؟",
      "menuHint": "خروجی، ترجیحات، زبان ها، ..."
    },
    "defaults": {
      "menuHint": "خروجی، ترجیحات، وبیشتر ...",
      "center_heading": "نمودارها .ساخته شده. ساده.",
      "toolbarHint": "ابزاری را انتخاب کنید و نقاشی را شروع کنید!",
      "helpHint": "میانبرها و راهنما"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "رنگ‌ها",
    "shades": "جلوه‌ها",
    "hexCode": "کدِ هگز",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "ذخیره در دیسک",
        "button": "ذخیره در دیسک",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "بارگذاری از فایل",
        "button": "بارگذاری از فایل",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "پیش‌نمایش"
  }
}
